module.exports = __webpack_public_path__ + "img/warning-sc.ec2a2d48.svg";